import car1 from "@/assets/car-1.jpg";
import car2 from "@/assets/car-2.jpg";
import car3 from "@/assets/car-3.jpg";
import car4 from "@/assets/car-4.jpg";
import car5 from "@/assets/car-5.jpg";
import car6 from "@/assets/car-6.jpg";
import type { Vehicle } from "@/domain/models/vehicle";

export type { Vehicle } from "@/domain/models/vehicle";
export { formatMiles, formatPrice } from "@/domain/models/vehicle";

export const VEHICLES: Vehicle[] = [
  {
    id: "audi-rs7-2024",
    brand: "Audi",
    model: "RS7 Sportback Performance",
    year: 2024,
    price: 138900,
    mileage: 1200,
    transmission: "Automatic",
    fuel: "Gasoline",
    body: "Sedan",
    condition: "New",
    available: true,
    power: 621,
    acceleration: 3.4,
    topSpeed: 305,
    drivetrain: "Quattro AWD",
    color: "Mythos Black",
    image: car1,
    gallery: [car1, car3, car4],
    features: ["Carbon ceramic brakes", "Bang & Olufsen 3D", "Matrix LED", "Adaptive air suspension"],
    description:
      "A four-door grand tourer that pairs 621 horsepower with the everyday composure of a luxury sedan. Handcrafted Valcona leather, carbon fiber trim, and a dynamic exhaust worthy of the RS badge.",
    tag: "Signature",
  },
  {
    id: "bmw-x7-2024",
    brand: "BMW",
    model: "X7 M60i xDrive",
    year: 2024,
    price: 112400,
    mileage: 3800,
    transmission: "Automatic",
    fuel: "Gasoline",
    body: "SUV",
    condition: "Certified",
    available: true,
    power: 523,
    acceleration: 4.5,
    topSpeed: 250,
    drivetrain: "xDrive AWD",
    color: "Mineral White",
    image: car2,
    gallery: [car2, car1, car5],
    features: ["Sky Lounge panoramic roof", "Executive rear seating", "Bowers & Wilkins Diamond", "Iconic Glow grille"],
    description:
      "A commanding seven-seat flagship with a twin-turbo V8, executive lounge rear cabin, and a presence that redefines the full-size luxury SUV segment.",
  },
  {
    id: "ford-mustang-2023",
    brand: "Ford",
    model: "Mustang GT Premium",
    year: 2023,
    price: 54900,
    mileage: 12400,
    transmission: "Manual",
    fuel: "Gasoline",
    body: "Coupe",
    condition: "Used",
    available: true,
    power: 480,
    acceleration: 4.2,
    topSpeed: 250,
    drivetrain: "RWD",
    color: "Atlas Blue",
    image: car3,
    gallery: [car3, car6, car5],
    features: ["Recaro sport seats", "Active valve exhaust", "MagneRide dampers", "Brembo six-piston"],
    description:
      "A modern American icon with a naturally aspirated V8 soundtrack, six-speed manual, and the mechanical honesty that keeps enthusiasts loyal.",
    tag: "Enthusiast",
  },
  {
    id: "polestar-4-2025",
    brand: "Polestar",
    model: "4 Long Range Performance",
    year: 2025,
    price: 72500,
    mileage: 0,
    transmission: "Automatic",
    fuel: "Electric",
    body: "Coupe",
    condition: "New",
    available: true,
    power: 544,
    acceleration: 3.8,
    topSpeed: 200,
    drivetrain: "Dual-motor AWD",
    color: "Snow",
    image: car4,
    gallery: [car4, car1, car2],
    features: ["Rear-facing camera roof", "Nappa ventilated seats", "Harman Kardon 1400W", "800V architecture"],
    description:
      "A Scandinavian design manifesto on wheels — vegan interiors, minimalist controls, and 544 horsepower of silent, instant torque.",
    tag: "Electric",
  },
  {
    id: "mercedes-sl-2024",
    brand: "Mercedes-AMG",
    model: "SL 63 4MATIC+ Roadster",
    year: 2024,
    price: 189000,
    mileage: 640,
    transmission: "Dual-Clutch",
    fuel: "Gasoline",
    body: "Convertible",
    condition: "New",
    available: false,
    power: 577,
    acceleration: 3.6,
    topSpeed: 315,
    drivetrain: "4MATIC+ AWD",
    color: "Selenite Grey Magno",
    image: car5,
    gallery: [car5, car6, car1],
    features: ["Fabric soft-top in 15s", "Rear-axle steering", "AMG DYNAMIC PLUS", "Burmester High-End"],
    description:
      "The reborn AMG SL — a hand-built roadster with a hot-inside-V twin-turbo V8, active aerodynamics, and a fabric roof that opens the sky in under fifteen seconds.",
    tag: "Reserved",
  },
  {
    id: "aston-vantage-2024",
    brand: "Aston Martin",
    model: "Vantage",
    year: 2024,
    price: 194500,
    mileage: 2100,
    transmission: "Automatic",
    fuel: "Gasoline",
    body: "Coupe",
    condition: "Certified",
    available: true,
    power: 656,
    acceleration: 3.4,
    topSpeed: 325,
    drivetrain: "RWD",
    color: "Podium Green",
    image: car6,
    gallery: [car6, car5, car3],
    features: ["Carbon fiber roof", "Adaptive dampers", "Michelin Pilot Sport S 5", "Bowers & Wilkins"],
    description:
      "British muscle refined to a razor edge — 656 horsepower, an eight-speed transaxle, and a hand-stitched cabin that feels engineered by tailors.",
    tag: "Featured",
  },
];

export const BRANDS = Array.from(new Set(VEHICLES.map((v) => v.brand))).sort();
export const BODIES = Array.from(new Set(VEHICLES.map((v) => v.body))).sort();
export const FUELS = Array.from(new Set(VEHICLES.map((v) => v.fuel))).sort();
export const TRANSMISSIONS = Array.from(new Set(VEHICLES.map((v) => v.transmission))).sort();
export const CONDITIONS = Array.from(new Set(VEHICLES.map((v) => v.condition))).sort();
